import api from '@/config/api'
import vuex from '@/store'

export default {
  getDestinations(skipCache) {
    // return 'Not implemented yet'
    const station = vuex.getters.currentStation.station

    return api.get(`/v2/newsdesk/uploader/${station}/destinations`, {
      cache: {
        maxAge: 30 * 1000,
        ignoreCache: skipCache ?? false
      }
    })
  }
  // uploadVideo(id, skipCache) {
  //   return 'Not implemented yet'
  //   const station = vuex.getters.currentStation.station

  //   return api.get(`/v2/newsdesk/uploader/${station}/video/${id}`, {
  //     cache: {
  //       maxAge: 30 * 1000,
  //       ignoreCache: skipCache ?? false
  //     }
  //   })
  // }
}
